function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Geometry from './Geometry';
import CoordinateFilter from './CoordinateFilter';
import hasInterface from '../../../../hasInterface';
import GeometryComponentFilter from './GeometryComponentFilter';
import Dimension from './Dimension';
import GeometryFilter from './GeometryFilter';
import CoordinateSequenceFilter from './CoordinateSequenceFilter';
import Puntal from './Puntal';
import Envelope from './Envelope';
import Assert from '../util/Assert';
var Point = /*#__PURE__*/function (_Geometry) {
  function Point() {
    var _this;
    _classCallCheck(this, Point);
    _this = _callSuper(this, Point);
    Point.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(Point, _Geometry);
  return _createClass(Point, [{
    key: "computeEnvelopeInternal",
    value: function computeEnvelopeInternal() {
      if (this.isEmpty()) {
        return new Envelope();
      }
      var env = new Envelope();
      env.expandToInclude(this._coordinates.getX(0), this._coordinates.getY(0));
      return env;
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      return this.isEmpty() ? [] : [this.getCoordinate()];
    }
  }, {
    key: "equalsExact",
    value: function equalsExact() {
      if (arguments.length === 2 && typeof arguments[1] === 'number' && arguments[0] instanceof Geometry) {
        var other = arguments[0];
        var tolerance = arguments[1];
        if (!this.isEquivalentClass(other)) {
          return false;
        }
        if (this.isEmpty() && other.isEmpty()) {
          return true;
        }
        if (this.isEmpty() !== other.isEmpty()) {
          return false;
        }
        return this.equal(other.getCoordinate(), this.getCoordinate(), tolerance);
      } else return _superPropGet(Point, "equalsExact", this, 1).apply(this, arguments);
    }
  }, {
    key: "normalize",
    value: function normalize() {}
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._coordinates.size() !== 0 ? this._coordinates.getCoordinate(0) : null;
    }
  }, {
    key: "getBoundaryDimension",
    value: function getBoundaryDimension() {
      return Dimension.FALSE;
    }
  }, {
    key: "getTypeCode",
    value: function getTypeCode() {
      return Geometry.TYPECODE_POINT;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return 0;
    }
  }, {
    key: "getNumPoints",
    value: function getNumPoints() {
      return this.isEmpty() ? 0 : 1;
    }
  }, {
    key: "reverse",
    value: function reverse() {
      return this.copy();
    }
  }, {
    key: "getX",
    value: function getX() {
      if (this.getCoordinate() === null) {
        throw new IllegalStateException('getX called on empty Point');
      }
      return this.getCoordinate().x;
    }
  }, {
    key: "compareToSameClass",
    value: function compareToSameClass() {
      if (arguments.length === 1) {
        var other = arguments[0];
        var point = other;
        return this.getCoordinate().compareTo(point.getCoordinate());
      } else if (arguments.length === 2) {
        var _other = arguments[0];
        var comp = arguments[1];
        var _point = _other;
        return comp.compare(this._coordinates, _point._coordinates);
      }
    }
  }, {
    key: "apply",
    value: function apply() {
      if (hasInterface(arguments[0], CoordinateFilter)) {
        var filter = arguments[0];
        if (this.isEmpty()) {
          return null;
        }
        filter.filter(this.getCoordinate());
      } else if (hasInterface(arguments[0], CoordinateSequenceFilter)) {
        var _filter = arguments[0];
        if (this.isEmpty()) return null;
        _filter.filter(this._coordinates, 0);
        if (_filter.isGeometryChanged()) this.geometryChanged();
      } else if (hasInterface(arguments[0], GeometryFilter)) {
        var _filter2 = arguments[0];
        _filter2.filter(this);
      } else if (hasInterface(arguments[0], GeometryComponentFilter)) {
        var _filter3 = arguments[0];
        _filter3.filter(this);
      }
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      return this.getFactory().createGeometryCollection();
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return Geometry.TYPENAME_POINT;
    }
  }, {
    key: "copy",
    value: function copy() {
      return new Point(this._coordinates.copy(), this._factory);
    }
  }, {
    key: "getCoordinateSequence",
    value: function getCoordinateSequence() {
      return this._coordinates;
    }
  }, {
    key: "getY",
    value: function getY() {
      if (this.getCoordinate() === null) {
        throw new IllegalStateException('getY called on empty Point');
      }
      return this.getCoordinate().y;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._coordinates.size() === 0;
    }
  }, {
    key: "init",
    value: function init(coordinates) {
      if (coordinates === null) {
        coordinates = this.getFactory().getCoordinateSequenceFactory().create([]);
      }
      Assert.isTrue(coordinates.size() <= 1);
      this._coordinates = coordinates;
    }
  }, {
    key: "isSimple",
    value: function isSimple() {
      return true;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Point;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Puntal];
    }
  }]);
}(Geometry);
export { Point as default };
Point.constructor_ = function () {
  this._coordinates = null;
  var coordinates = arguments[0];
  var factory = arguments[1];
  Geometry.constructor_.call(this, factory);
  this.init(coordinates);
};
Point.serialVersionUID = 4902022702746614570;